export default function Validation(formData) {
  const errors = {};
  const email_pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  const phone_pattern = /^\d{10}$/;
  if (formData.firstName?.trim() === "") {
    errors.firstName = "First name is required";
  }
  if (formData?.lastName?.trim() === "") {
    errors.lastName = "Last name is required";
  }
  if (formData.email?.trim() === "") {
    errors.email = "Email is required";
  } else if (!email_pattern.test(formData?.email)) {
    errors.email = "Invalid email format";
  }
  if (formData.phone?.trim() === "") {
    errors.phone = "Phone number is required";
  } else if (!phone_pattern.test(formData?.phone)) {
    errors.phone = "Invalid phone number";
  }
  if (formData.message?.trim() === "") {
    errors.message = "Please provide your feedback";
  }
  if (!formData.rating) {
    errors.rating = "Please give rating";
  }

  return errors;
}

export function EnquiryValidation(enquiryFormData) {
  const errors = {};
  const email_pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  const phone_pattern = /^\d{10}$/;
  const pincode_pattern = /^\d{6}$/;

  if (!enquiryFormData.enquiryType) {
    errors.enquiryType = "Please select an enquiry type";
  }
  if (enquiryFormData.name.trim() === "") {
    errors.name = "Name is required";
  }
  if (enquiryFormData.email.trim() === "") {
    errors.email = "Email is required";
  } else if (!email_pattern.test(enquiryFormData.email)) {
    errors.email = "Invalid email format";
  }
  if (enquiryFormData.phone.trim() === "") {
    errors.phone = "Phone number is required";
  } else if (!phone_pattern.test(enquiryFormData.phone)) {
    errors.phone = "Invalid phone number";
  }
  if (enquiryFormData.pincode.trim() === "") {
    errors.pincode = "Pincode is required";
  } else if (!pincode_pattern.test(enquiryFormData.pincode)) {
    errors.pincode = "Invalid pincode";
  }
  if (enquiryFormData.message.trim() === "") {
    errors.message = "Please provide details about your enquiry";
  }

  return errors;
}

export  function SiteSurveyValidation(formData) {
  const errors = {};
  const email_pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  const phone_pattern = /^\d{10}$/;
  if (formData.firstName?.trim() === "") {
    errors.firstName = "First name is required";
  }
  if (formData?.lastName?.trim() === "") {
    errors.lastName = "Last name is required";
  }
  if (formData.email?.trim() === "") {
    errors.email = "Email is required";
  } else if (!email_pattern.test(formData?.email)) {
    errors.email = "Invalid email format";
  }
  if (formData.phone?.trim() === "") {
    errors.phone = "Phone number is required";
  } else if (!phone_pattern.test(formData?.phone)) {
    errors.phone = "Invalid phone number";
  }
 

  return errors;
}